"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ = require("./..");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(_styles.default, {
  name: 'Footer'
});

var Footer = function Footer(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  var classes = useStyles();
  var year = new Date().getFullYear();
  return /*#__PURE__*/_react.default.createElement(_core.Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
    className: classes.root
  }), /*#__PURE__*/_react.default.createElement(_.Divider, {
    className: classes.spacer
  }), /*#__PURE__*/_react.default.createElement(_.Typography, {
    variant: "body1"
  }, year, " \xA9", ' ', /*#__PURE__*/_react.default.createElement(_core.Link, {
    component: "a",
    href: "https://www.yapay.com.br",
    target: "_blank"
  }, "Yapay Pagamentos"))));
};

Footer.propTypes = {
  className: _propTypes.default.string
};
var _default = Footer;
exports.default = _default;